module.exports = __webpack_public_path__ + "static/vinh-abdac0ddc84f100683e134601f7762c4.jpg";